import { UserRequestFilters } from "./UserRequestsFilterPanel";

export const defUserRequestsFilters: UserRequestFilters = {
    statusOptions: [
        {
            uniqueName: "NEW",
            name: "_Nowy",
            translationCode: "user-requests-new",
            selected: false
        },
        {
            uniqueName: "CLOSED",
            name:"_Zamknięty",
            translationCode: "user-requests-closed",
            selected: false
        },
        {
            uniqueName: "REJECTED",
            name: "_Odrzucony",
            translationCode: "user-requests-rejected",
            selected: false
        }
    ]
}